export default "__VITE_ASSET__DTly$kuH__"